import type { ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/utils";

import { MuiTypography } from "./mui-typography";

// The donor's `PageContainer` (`timmy/src/components/page-container/
// page-container.tsx`), which frames every page it has.
//
// MUI `Container` with `maxWidth={false}` and `disableGutters`, and its own
// padding in their place: `paddingTop: 3`, `paddingBottom: 3`, `px: 5` — 24px
// and 40px, **flat at every width** (MUI's responsive gutters are exactly what
// `disableGutters` turns off). With no max width the frame is the full width
// of whatever holds it.
//
// The authed chrome supplies no gutter, deliberately, so each page owns it —
// which is why the anonymous product page, which has no chrome at all, frames
// itself the same way through this. The catalog list, both details pages, the
// edit page and Admin spelled `px-10 py-6` out four times before this.
//
// A caller's own layout (the list page's column, its gap) rides `className`;
// the padding is this component's.

export function PageContainer({ className, ...props }: ComponentPropsWithoutRef<"div">) {
  return <div {...props} className={cn("w-full px-10 py-6", className)} />;
}

/**
 * The page title every donor page draws first inside its container:
 * `<Typography variant='h1'>`, the page's one `h1`, in `text.primary`.
 *
 * The space under it is the page's, not the heading's — the list page puts
 * 32px there, the edit page's form carries its own — so it rides `className`.
 */
export function PageHeading({ className, ...props }: ComponentPropsWithoutRef<"h1">) {
  return (
    <MuiTypography {...props} variant="h1" component="h1" color="primary" className={className} />
  );
}
